import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../hooks/store';
import './DateSwitch.css';

export interface DateSwitchProps {
    current: string; // YYYY-MM-DD
    onChange: (date: string) => void; // YYYY-MM-DD
    className?: 'white'|'oldlace';
};

type DateItem = {
    date: string; // YYYY-MM-DD
    human_ru: string; // 1 Декабря
    human_en: string; // 1 December
};

const DateSwitch: FC<DateSwitchProps> = ({ current, onChange, className }) => {
	const { i18n } = useTranslation();
    const human = i18n.language === 'en' ? 'human_en' : 'human_ru';
    const slots = useAppSelector(store => store.slots);
    const [ list, setList ] = useState<DateItem[]>([]);

    // Формируем список дат
    useEffect(() => {
        let date = '';
        let list: DateItem[] = [];
        for(let i = 0; i < slots.length; i ++) {
            const current = slots[i].start.split('T')[0];
            const human_ru = slots[i].date_ru;
            const human_en = slots[i].date_en;
            if(date !== current) {
                date = current;
                list.push({ date, human_ru, human_en });
            }
        }
        if(list.length) {
            onChange(list[0].date);
            setList(list);
        }
    }, [ slots, onChange ]);

    // Отрисовка вкладки даты
    const draw = (date: DateItem) => {
        if(date.date === current)
            return <li key={date.date} className='current'>{date[human]}</li>;
        else
            return <li key={date.date} onClick={() => onChange(date.date)}>{date[human]}</li>;
    };

    return (
        <ul className={className ? `DateSwitch ${className}` : 'DateSwitch'}>
        {list.map(date => draw(date))}
        </ul>
	);
};

export default DateSwitch;
